import axios from 'axios';
import constants from 'src/common/constants';

export async function getAll({ commit }) {
  const response = await axios.get(constants.AIR_QUALITY_API);
  if (response.status === 200) {
    commit('setAllStations', response.data);
  }
}
